import { Shield } from "lucide-react";
import InfoBanner from "../ui/InfoBanner";
import SecretInput from "../ui/SecretInput";
import CheckboxGroup from "../ui/CheckboxGroup";
import { PERMISSION_OPTIONS } from "../constants/connectionMethods";

export default function McpConnection({
  mcpServerUrl,
  setMcpServerUrl,
  protocolVersion,
  setProtocolVersion,
  timeout,
  setTimeout,
  authToken,
  setAuthToken,
  permissions,
  setPermissions
}) {
  const handlePermissionChange = (permissionId, checked) => {
    setPermissions({
      ...permissions,
      [permissionId]: checked
    });
  };

  return (
    <>
      {/* MCP Info */}
      <InfoBanner
        icon={Shield}
        title="Model Context Protocol"
        description="Enable agentic workflows with Bench and Studio using MCP integration."
      />

      {/* MCP Server URL */}
      <div>
        <label className="block text-sm font-semibold text-gray-900 mb-2">
          MCP Server URL <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={mcpServerUrl}
          onChange={(e) => setMcpServerUrl(e.target.value)}
          placeholder="mcp://server.example.com:8080"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      {/* Protocol Version and Timeout */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-gray-900 mb-2">
            Protocol Version
          </label>
          <select
            value={protocolVersion}
            onChange={(e) => setProtocolVersion(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="v1.0">MCP v1.0 (Recommended)</option>
            <option value="v0.9">MCP v0.9</option>
            <option value="v0.8">MCP v0.8</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-900 mb-2">
            Timeout (seconds)
          </label>
          <input
            type="number"
            value={timeout}
            onChange={(e) => setTimeout(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>

      {/* Authentication Token */}
      <SecretInput
        label="Authentication Token"
        value={authToken}
        onChange={setAuthToken}
        placeholder="Enter MCP authentication token"
        required
      />

      {/* Context Permissions */}
      <CheckboxGroup
        label="Context Permissions"
        options={PERMISSION_OPTIONS}
        values={permissions}
        onChange={handlePermissionChange}
      />
    </>
  );
}
